"use strict";

exports.__esModule = true;
exports.AdvancedDataTableColumnFields = AdvancedDataTableColumnFields;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _AdvancedTimeline = require("../../Timeline/AdvancedTimeline");
var _Translator = require("../../Core/Translator");
var _Fields = require("../DataTableColumn/Fields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Well = _styledComponents["default"].div.withConfig({
  displayName: "AdvancedDataTableColumnFields__Well",
  componentId: "sc-1vu0lbv-0"
})(["margin-bottom:20px;"]);
var isNonFilterableColumn = function isNonFilterableColumn(type) {
  var nonFilterableColumnTypes = ["date", "duration"];
  return nonFilterableColumnTypes.includes(type);
};

/**
 * Fields for AdvancedDataTableColumnElement.
 */
function AdvancedDataTableColumnFields(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var _element$props = element.props,
    id = _element$props.id,
    sanitizedFieldName = _element$props.sanitizedFieldName,
    label = _element$props.label,
    hideTypeSelector = _element$props.hideTypeSelector,
    name = _element$props.name,
    type = _element$props.type,
    dateFormat = _element$props.dateFormat,
    defaultWidth = _element$props.defaultWidth,
    defaultSortOrder = _element$props.defaultSortOrder,
    canFilter = _element$props.canFilter,
    exactMatch = _element$props.exactMatch,
    defaultFilterValue = _element$props.defaultFilterValue,
    enableSorting = _element$props.enableSorting;
  var isExactMatch = exactMatch !== false;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineColumnField, {
    value: sanitizedFieldName
  }), label ? /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineTitleField, {
    value: label,
    setProp: function setProp(val) {
      return elementEditor.setProps(path, {
        label: val,
        titleOverridden: !!val
      });
    }
  }) : /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineTitleField, {
    value: name,
    setProp: function setProp(val) {
      return elementEditor.setProps(path, {
        name: val,
        titleOverridden: !!val
      });
    }
  }), !hideTypeSelector ? /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineDataTypeField, {
    type: type,
    setType: function setType(val) {
      var newProps = Object.assign({}, element.props, {
        type: val,
        showBarChart: false,
        barChartBackgroundColor: "#68ccca",
        barChartScaleSource: "auto"
      });

      // Users should not be able to filter Date
      if (newProps.type === "date" || newProps.type === "duration") {
        newProps.canFilter = false;
      }
      elementEditor.setProps(path, newProps);
    }
  }) : null, (type === "duration" || type === "number" || type === "fractionalPercent") && /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineBarChartField, {
    path: path,
    elementEditor: elementEditor,
    element: element
  }), "\xA0 \xA0", type === "date" && /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineDateFormatField, {
    dateFormat: dateFormat,
    setDateFormat: function setDateFormat(val) {
      return elementEditor.setProp(path, "dateFormat", val);
    }
  }), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTable.defaultColumnWidth.label", "Column Width (in pixels)"),
    helperText: translate("DataTable.defaultColumnWidth.helperText", "Leave it blank for auto width")
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    min: 0,
    onValueChange: function onValueChange(value) {
      return elementEditor.setProp(path, "defaultWidth", value);
    },
    value: defaultWidth ? defaultWidth : ""
  }))), !isNonFilterableColumn(type) && /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    disabled: isNonFilterableColumn(type),
    label: translate("DataTableFields.showFilter.label", "Enable Filtering"),
    checked: !isNonFilterableColumn(type) && canFilter,
    onChange: function onChange() {
      var nextCanFilter = !canFilter;
      var updates = {
        canFilter: nextCanFilter
      };
      if (nextCanFilter) {
        updates.exactMatch = true;
      }
      elementEditor.setProps(path, updates);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    disabled: !canFilter,
    label: translate("DataTableFields.exactMatch.label", "Exact match"),
    checked: isExactMatch,
    onChange: function onChange() {
      elementEditor.setProp(path, "exactMatch", !isExactMatch);
    }
  }), !isNonFilterableColumn(type) && canFilter && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTable.defaultFilterValue.label", "Default filter value")
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    disabled: !canFilter,
    key: name,
    value: defaultFilterValue,
    onInput: function onInput(e) {
      elementEditor.setProp(path, "defaultFilterValue", e.target.value);
    }
  })))), type === "duration" || id === "duration" ? /*#__PURE__*/_react["default"].createElement(_Fields.SortableField, {
    enableSort: enableSorting,
    setSortable: function setSortable(val) {
      return elementEditor.setProp(path, "enableSorting", val);
    },
    defaultSortOrder: defaultSortOrder || "NONE",
    setSortOrder: function setSortOrder(val) {
      return elementEditor.setProp(path, "defaultSortOrder", val);
    }
  }) : /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.TimelineSortableField, {
    enableSort: enableSorting,
    setSortable: function setSortable(val) {
      return elementEditor.setProp(path, "enableSorting", val);
    }
  }));
}